if (!window['HRX']) HRX = {};

if (!HRX['PAGESCOPE']) HRX.PAGESCOPE = {};

if (!HRX['calendar']) HRX.calendar = {};

if (!HRX['components']) HRX.components = {};

if (!HRX['RF_Patch']) HRX.RF_Patch = {};

if (!HRX['NAV']) HRX.NAV = {};

HRX.calendar.isFutureDate = function (day) {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    return day.date.getTime() - date.getTime() >= 0;
};

HRX.calendar.disabledPassedDayClass = function(day) {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    return (day.date.getTime() - date.getTime()  < 0) ? "rich-calendar-boundary-dates" : "";
};

HRX.getValueFromArrayOrLast = function(arr, index) {
    return (arr instanceof Array) ? ((arr.length > 0) ? ((arr.length > index) ? arr[index] : arr[arr.length - 1]) : null) : arr;
};

HRX.getValueFromArrayOrNull = function(arr, index) {
    return (arr instanceof Array) ? ((arr.length > index)  ? arr[index] : null) : arr;
};

HRX.getViewport = function () {
    const win = jQuery(window);
    const viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
    };
    viewport.bottom = viewport.top + win.height();
    viewport.right = viewport.left + win.width();
    return viewport;
};
HRX.RF_Patch._suggestDropdownCheckCounter = 0;
HRX.RF_Patch.startSuggestReposition = function() {
    const $ = jQuery, patch = HRX.RF_Patch;
    function stopInterval() {
        patch._suggestDropdownCheckCounter = 0;
        if (patch._suggestDropdownChecker) {
            clearInterval(patch._suggestDropdownChecker);
            delete patch._suggestDropdownChecker
        }
    }
    if (patch._suggestDropdownCheckCounter > 0) patch._suggestDropdownCheckCounter = 15;
    if (!patch._suggestDropdownChecker) {
        patch._suggestDropdownCheckCounter = 15;

        patch._suggestDropdownChecker = setInterval(function() {
            patch._suggestDropdownCheckCounter--;
            if (patch._suggestDropdownCheckCounter <= 0) stopInterval();
            const panel = $('body>div.dr-sb-common-container.rich-sb-common-container:visible');
            if (panel.size() && panel.eq(0).offset().top > 0) {
                stopInterval();
                const viewport = HRX.getViewport();
                panel.each(function() {
                    const $this = jQuery(this);
                    const bounds = $this.offset();
                    bounds.bottom = bounds.top + $this.outerHeight();
                    if (viewport.bottom < bounds.bottom) $this.offset({top: bounds.top - $this.outerHeight() - 25})
                })
            }
        }, 20)
    }
};

/**
 * sessionRefresher
 */

HRX.SessionRefresher = function(interval) {
    this.interval = typeof(interval) !== "undefined" ? interval : 0;
    this.timer = null;
    this.started = false;
};

HRX.SessionRefresher.prototype.start = function() {
    if (!this.started && this.interval > 0) {
        this.started = true;
        this.timer = setInterval(function() {refreshSession();}, this.interval);
    }
};

HRX.SessionRefresher.prototype.stop = function() {
    if (this.started && this.timer) {
        clearInterval(this.timer);
    }
    this.started = false;
};

/**
 * Save mouse position
 */
if (!HRX['cursor']) (HRX.cursor = {X:0,Y:0});
HRX.SaveEventCursorPosition = function(event) {
    if (typeof(event.pageX) !== 'undefined' ) {
        HRX.cursor.X = event.pageX;
        HRX.cursor.Y = event.pageY;
    } else if (typeof(event.clientX) !== 'undefined') {
        HRX.cursor.X = event.clientX + jQuery(window).scrollLeft();
        HRX.cursor.Y = event.clientY + jQuery(window).scrollTop();
    } else {
        HRX.cursor.X = jQuery(this).offset().left;
        HRX.cursor.Y = jQuery(this).offset().top;
    }
};

/*focus selector*/
jQuery.expr[':'].focus = function(elem) {
    return elem === document.activeElement && (elem.type || elem.href);
};

/*JSF id to selector*/
HRX.idToSelector = function(id) {
    return id.replace(/:/g, "\\:");
};

/*caret plugin*/
HRX.setSelection = function(field, start, end) {
    const el = jQuery(field).get(0);
    el.focus();
    if (el.setSelectionRange) {
        el.setSelectionRange(start, end);
    } else if (el.createTextRange) {
        const range = el.createTextRange();
        range.collapse(true);
        range.moveEnd('character', end);
        range.moveStart('character', start);
        range.select();
    }
}

;(function($, len, createRange, duplicate) {
    $.fn.caret = function(options, opt2) {
        let start, end, t = this[0],
            browser = $.browser.msie;
        if (typeof options === "object" && typeof options.start === "number" && typeof options.end === "number") {
            start = options.start;
            end = options.end;
        } else if (typeof options === "number" && typeof opt2 === "number") {
            start = options;
            end = opt2;
        } else if (typeof options === "string") {
            if ((start = t.value.indexOf(options)) > -1) end = start + options[len];
            else start = null;
        } else if (Object.prototype.toString.call(options) === "[object RegExp]") {
            const re = options.exec(t.value);
            if (re !== null) {
                start = re.index;
                end = start + re[0][len];
            }
        }
        if (typeof start !== "undefined") {
            if (browser) {
                const selRange = this[0].createTextRange();
                selRange.collapse(true);
                selRange.moveStart('character', start);
                selRange.moveEnd('character', end - start);
                selRange.select();
            } else {
                this[0].selectionStart = start;
                this[0].selectionEnd = end;
            }
            this[0].focus();
            return this
        } else {
            let range, s, e;
            if (browser) {
                const selection = document.selection;
                if (this[0].tagName.toLowerCase() !== "textarea") {
                    const val = this.val();
                    range = selection[createRange]()[duplicate]();
                    range.moveEnd("character", val[len]);
                    s = (range.text === "" ? val[len] : val.lastIndexOf(range.text));
                    range = selection[createRange]()[duplicate]();
                    range.moveStart("character", -val[len]);
                    e = range.text[len];
                } else {
                    range = selection[createRange]();
                    const stored_range = range[duplicate]();
                    stored_range.moveToElementText(this[0]);
                    stored_range.setEndPoint('EndToEnd', range);
                    s = stored_range.text[len] - range.text[len];
                    e = s + range.text[len];
                }
            } else {
                s = t.selectionStart;
                e = t.selectionEnd;
            }
            const te = t.value.substring(s, e);
            return {
                start: s,
                end: e,
                text: te,
                replace: function(st) {
                    return t.value.substring(0, s) + st + t.value.substring(e, t.value[len])
                }
            }
        }
    }
})(jQuery, "length", "createRange", "duplicate")

/* component plugins*/
;(function($) { /* CheckBoxCombo */
    $.fn.hrxDropdown = function(options) {

        const opts = jQuery.extend({}, $.fn.hrxDropdown.defaults, options);

        let img = new Image();
        img.src = opts.image;
        img.src = opts.checkedImage;
        img = null;

        const removeDropdown = function(dropdown) {
                if (dropdown.length > 0) {
                    dropdown.remove();
                }
            };
        const adjustItemsByValue = function(opts) {
                const fieldValue = opts.field.val() + opts.separator;
                _(opts.items).each(function(item) {
                    item.isChecked = fieldValue.indexOf(item.value + opts.separator) >= 0;
                });
            };
        $('.' + opts.optionClassName).die('click');

        return this.each(function() {
            const button = $(this);
            if (opts.field) {
                opts.field = $(opts.field);
            } else {
                opts.field = button.parent().children("input");
            }
            let onclick = function(e) {
                    const offset = opts.field.offset();
                    const top = offset.top + opts.positionOffset;
                    const width = opts.field.outerWidth();
                    if ($('.' + opts.className).length > 0) {
                        removeDropdown(jQuery('.' + opts.className));
                    } else if (opts.items.length) {
                        adjustItemsByValue(opts);
                        let dropdown = $('<div class="' + opts.className + '" tabindex="-1"></div>').css({
                            top: top,
                            left: offset.left,
                            width: width,
                            display: "none"
                        }).blur(function() {
                            removeDropdown($('.' + opts.className));
                        }).appendTo('body');
                        let upward = ((top - $(window).scrollTop()) + dropdown.outerHeight()) > $(window).height();
                        if (upward) {
                            dropdown.css({
                                top: offset.top - dropdown.outerHeight()
                            });
                        } /*setting focus in the callback is not working*/
                        dropdown.show().focus();
                        $.each(opts.items, function(i, item) {
                            let image = item.isChecked ? opts.checkedImage : opts.image;
                            $('<div class="' + opts.optionClassName + '" style="cursor:default" id="' + item.key + '" ><img src="' + image + '" />' + item.value + '</div>').click(function() {
                                const img = $(this).children('img:first');
                                let isChecked = false;
                                if (img.attr('src') === opts.checkedImage) {
                                    img.attr('src', opts.image);
                                    item.isChecked = false;
                                } else {
                                    img.attr('src', opts.checkedImage);
                                    item.isChecked = true;
                                    isChecked = true;
                                }
                                if (opts.autoFill) {
                                    opts.field.val(
                                    opts.items.filter(function(v) {
                                        return v.isChecked;
                                    }).map(function(v) {
                                        return v.value;
                                    }).join(opts.separator));
                                }
                                opts.itemClick(opts.field, opts.items, $(this).attr('id'), jQuery(this).text(), isChecked, opts.separator);
                                e.preventDefault();
                            }).appendTo('.' + opts.className);
                        });
                        $('.' + opts.className).show();
                    }
                    e.preventDefault();
                    return false;
                };
            $(button).click(onclick);
            opts.field.mousedown(onclick);
            onclick = null;
        });

    };

    $.fn.hrxDropdown.defaults = {
        items: [],
        image: '/rasp6/img/components/checkboxcombo/checkbox.gif',
        checkedImage: '/rasp6/img/components/checkboxcombo/checked.gif',
        positionOffset: 20,
        className: 'dropDownMenu',
        optionClassName: 'optionCheckbox',
        field: null,
        autoFill: false,
        dropdownHeight: 200,
        itemClick: function(key, value, isChecked) {},
        separator: ', '
    }; /* End of CheckBoxCombo */


    /* Expendable Textfield */
    $.fn.hrxExpandableTextfield = function(options) {
        //for safari, only work on version 5.1.1 or above
        const opts = $.extend({}, jQuery.fn.hrxExpandableTextfield.defaults, options);
        return this.each(function() {
            const field = $(this);
            let popupField = null;
            let onfocus = function() {
                    const offset = field.offset();
                    const height = field.height();
                    let width = opts.width || field.outerWidth();
                    if (opts.widthAnchor) {
                        if ($(opts.widthAnchor).length > 0) {
                            width = $(opts.widthAnchor).outerWidth() - (offset.left - $(opts.widthAnchor).offset().left) - opts.rightMargin;
                        }
                    }
                    const wrapper = $('<div class="' + opts.wrapperClass + '"><h1>' + opts.header + '</h1><input class="' + opts.popupClass + '"/></div>').css({
                        width: width + opts.wrapperPadding * 2 - 20,
                        padding: opts.wrapperPadding
                    }).appendTo('body');
                    wrapper.attr('id', field.attr('id') + 'PopupWrapper');
                    if (!opts.freePosition) wrapper.css({
                        top: offset.top - opts.wrapperPadding + opts.offsetTop,
                        left: offset.left - opts.wrapperPadding + opts.offsetLeft
                    });
                    popupField = wrapper.children('input').eq(0).val(field.val()).css({
                        width: width,
                        height: height
                    }).keyup(function() {
                        field.val($(this).val())
                    }).blur(function() {
                        field.val($(this).val());
                        setTimeout(() => { if (!field.is(':focus')) wrapper.remove() }, 50);
                    });
                    popupField.attr('id', field.attr('id') + 'PopupField');
                    if (opts.autoFocus) {
                        HRX.setSelection(popupField, field.caret().start, field.caret().end);
                        popupField.focus();
                    }
                };
            $(field).focus(onfocus).keyup(function() {
                if (popupField) popupField.val($(this).val());
            }).blur(function() {
                setTimeout(() => {if (!popupField.is(':focus')) popupField.parent().remove();}, 50);
            });
        });
    };

    $.fn.hrxExpandableTextfield.defaults = {
        offsetTop: 0,
        offsetLeft: 0,
        freePosition: false,
        width: null,
        popupClass: 'popupTextfield',
        wrapperClass: 'popupTextfieldWrapper',
        wrapperPadding: 10,
        widthAnchor: null,
        rightMargin: 10,
        autoFocus: false,
        header: ''
    }; /* End of expandable textfield */
})(jQuery)

/*
 * Auto-growing textareas
 */
;(function($) {
    $.fn.hrxAutoGrowTextArea = function(options) {
        var opts = $.extend({}, $.fn.hrxAutoGrowTextArea.defaults, options);
        if (opts.lengthErrorElement) opts.lengthErrorElement = $(opts.lengthErrorElement);
        if (opts.remainCounter) opts.remainCounter = $(opts.remainCounter);
        this.filter('textarea').each(function() {

            var $this = $(this),
                minHeight = $this.height(),
                lineHeight = $this.css('lineHeight'),
                lengthAlerted = false;

            var shadow = $('<div></div>').css({
                position: 'absolute',
                top: -10000,
                left: -10000,
                width: $(this).width() - parseInt($this.css('paddingLeft')) - parseInt($this.css('paddingRight')),
                fontSize: $this.css('fontSize'),
                fontFamily: $this.css('fontFamily'),
                lineHeight: $this.css('lineHeight'),
                resize: 'none'
            }).appendTo(document.body);

            var update = function() {

                    var times = function(string, number) {
                            for (var i = 0, r = ''; i < number; i++) r += string;
                            return r;
                        };

                    var val = this.value.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/\n$/, '<br/>&nbsp;').replace(/\n/g, '<br/>').replace(/ {2,}/g, function(space) {
                        return times('&nbsp;', space.length - 1) + ' '
                    });
                    var len = this.value.length;
                    if (opts.lengthLimit) {
                        if (len > opts.lengthLimit) {
                            if (opts.remainCounter) opts.remainCounter.text(len - opts.lengthLimit + " characters exceeded.").addClass("exceeded").removeClass("remaining");
                            if (opts.lengthErrorElement) {
                                if (!opts.lengthErrorElement.is(':visible')) opts.lengthErrorElement.fadeIn(300);
                            } else if (!lengthAlerted) {
                                lengthAlerted = true;
                                alert("Content length exceeds " + opts.lengthLimit + " characters. It is very likely not able to save correctly.");
                            }
                        } else {
                            if (opts.remainCounter) opts.remainCounter.text(opts.lengthLimit - len + " characters remaining.").addClass("remaining").removeClass("exceeded");
                            if (opts.lengthErrorElement && opts.lengthErrorElement.length > 0 && opts.lengthErrorElement.is(':visible')) opts.lengthErrorElement.fadeOut(300);
                            lengthAlerted = false;
                        }
                    }

                    shadow.html(val);
                    $(this).css('height', Math.min(opts.maxHeight, Math.max(shadow.height() + 20, minHeight)));

                };

            $(this).change(update).keyup(update).keydown(update);

            update.apply(this);

        });
        return this;
    };

    $.fn.hrxAutoGrowTextArea.defaults = {
        maxHeight: 600,
        lengthLimit: 0,
        remainCounter: null,
        lengthErrorElement: null
    }
})(jQuery)

/*iOS style toggle button*/
;(function($) {
    $.fn.iToggle = function(options) {

        clickEnabled = true;

        var defaults = {
            type: 'checkbox',
            keepLabel: true,
            easing: false,
            speed: 200,
            skin: '/rasp/mercury/themes/spring/components/itoggle/itoggle.png',
            width: 93,
            height: 27,
            onClick: function() {},
            onClickOn: function() {},
            onClickOff: function() {},
            onSlide: function() {},
            onSlideOn: function() {},
            onSlideOff: function() {}
        },
            settings = $.extend({}, defaults, options);

        this.each(function() {
            var $this = $(this);
            if ($this.attr('tagName') == 'INPUT') {
                var id = $this.attr('id');
                label(settings.keepLabel, id);
                $this.addClass('iT_checkbox');
                $('<label class="itoggle" for="' + id + '"><span></span></label>')
                    .insertBefore($this)
                    .click(function() {toggle($(this));return false;});
                if ($this.attr('checked')) {
                    $this.prev('label').addClass('iTon');
                } else {
                    $this.prev('label').addClass('iToff');
                }
            } else {
                $this.children('input:' + settings.type).each(function() {
                    var id = $(this).attr('id');
                    label(settings.keepLabel, id);
                    $(this).addClass('iT_checkbox').before('<label class="itoggle" for="' + id + '"><span></span></label>');
                    if ($(this).attr('checked')) {
                        $(this).prev('label').addClass('iTon');
                    } else {
                        $(this).prev('label').addClass('iToff');
                    }
                    if (settings.type == 'radio') {
                        $(this).prev('label').addClass('iT_radio');
                    }
                });
            }
            $this.prev('label').css('background-image', 'url("' + settings.skin + '")').css('width', settings.width).css('height', settings.height);
            $(this).get(0).slideOff = function() {
                var itoggle = $(this).prev('label.itoggle').eq(0);
                if (itoggle.hasClass('iTon')) {
                    toggle(itoggle, true);
                }
                clickEnabled = true;
            };
            $(this).get(0).slideOn = function() {
                var itoggle = $(this).prev('label.itoggle').eq(0);
                if (itoggle.hasClass('iToff')) {
                    toggle(itoggle, true);
                }
                clickEnabled = true;
            }
        });

        function label(e, id) {
            if (e === true) {
                if (settings.type == 'radio') {
                    $('label[for=' + id + ']').addClass('ilabel_radio');
                } else {
                    $('label[for=' + id + ']').addClass('ilabel').click(toggleLabel);
                }
            } else {
                $('label[for=' + id + ']').remove();
            }
        }

        function toggle(itoggleLabel, programmatic) {
            if (clickEnabled === true) {
                clickEnabled = false;
                if (itoggleLabel.hasClass('iT_radio')) {
                    if (itoggleLabel.hasClass('iTon')) {
                        clickEnabled = true;
                    } else {
                        slide(itoggleLabel, true, programmatic);
                    }
                } else {
                    slide(itoggleLabel, false, programmatic);
                }
            }
            return false;
        }

        function toggleLabel() {
            if (clickEnabled === true) {
                clickEnabled = false;
                slide($(this).next('label.itoggle').eq(0));
            }
            return false;
        }

        function slide($object, radio, programmatic) {
            if (typeof(programmatic) == "undefined") programmatic = false;
            if (!programmatic) settings.onClick.call($object); //Generic click callback for click at any state
            h = $object.innerHeight();
            t = HRX.idToSelector($object.attr('for'));
            if ($object.hasClass('iTon')) {
                if (!programmatic) settings.onClickOff.call($object); //Click that turns the toggle to off position
                $object.animate({
                    backgroundPosition: '100% -' + h + 'px'
                }, settings.speed, settings.easing, function() {
                    $object.removeClass('iTon').addClass('iToff');
                    clickEnabled = true;
                    if (!programmatic) settings.onSlide.call(this); //Generic callback after the slide has finnished
                    if (!programmatic) settings.onSlideOff.call(this); //Callback after the slide turns the toggle off
                });
                $('input#' + t).removeAttr('checked');
            } else {
                if (!programmatic) settings.onClickOn.call($object);
                $object.animate({
                    backgroundPosition: '0% -' + h + 'px'
                }, settings.speed, settings.easing, function() {
                    $object.removeClass('iToff').addClass('iTon');
                    clickEnabled = true;
                    if (!programmatic) settings.onSlide.call(this); //Generic callback after the slide has finnished
                    if (!programmatic) settings.onSlideOn.call(this); //Callback after the slide turns the toggle on
                });
                $('input#' + t).attr('checked', 'checked');
            }
            if (radio === true) {
                name = $('#' + t).attr('name');
                slide($object.siblings('label[for]'), false, programmatic);
            }
        }

    };
})(jQuery)


/*
 * Field merger
 */
;(function($) {
    $.fn.hrxFieldMerger = function(options) {
        let opts = $.extend({}, $.fn.hrxFieldMerger.defaults, options);
        opts.actualField = opts.field;
        opts.field = $(opts.field);
        //TODO US2069 No prototype.js anymore. For now as we testing migration on new browser the array should have sufficient APIs. We need to fix this when we start considering support old browsers.
        // opts.values = $A(opts.values);
        // opts.styleClasses = $A(opts.styleClasses);
        const fillField = function (value) {
            if (opts.handler) opts.handler(opts.field, value); else opts.field.val(value);
            if(opts.field.hasClass("ui-selectonemenu")){
            	if(PrimeFaces != undefined && PrimeFaces.getWidgetById(opts.field.attr("id")) != null){
            		PrimeFaces.getWidgetById(opts.field.attr("id")).selectValue(value);
            	}
            }
        };
        // const newValue = HRX.getValueFromArrayOrLast(opts.values, 0);
        // const newClass = HRX.getValueFromArrayOrLast(opts.styleClasses, 0);
        // const newLabel = HRX.getValueFromArrayOrNull(opts.labels, 0);
        const setValueStyle = function () {
            _.each(opts.styleClasses, c => opts.field.removeClass(c));
            const valueIdx = opts.values.indexOf(opts.field.val());
            if (valueIdx >= 0) {
                opts.field.addClass(HRX.getValueFromArrayOrLast(opts.styleClasses, valueIdx));
            }
            if (opts.triggerStyle === "toggle") {
                if (valueIdx > 0) opts.itoggle.slideOff(); else opts.itoggle.slideOn();
            }
        };
        return this.each(function() {
            const button = $(this);
            button.addClass('hrxMergeButton');
            button.get(0).setTo = function(idx) {
                const value = opts.values[idx];
                fillField(value);
                setValueStyle();
                if (opts.triggerStyle === "dropdown") $('.fieldMergerPopup').remove();
            };
            if (opts.adjustFieldWidth > 0) opts.field.width(opts.adjustFieldWidth);
            if (opts.triggerStyle === "dropdown") {
                let onclick = function (e) {
                    const offset = (opts.field.offset().top > 0) ? opts.field.offset() : $(opts.actualField).offset();
                    const top = offset.top + opts.offsetTop;
                    let width = opts.field.width();
                    if (opts.minWidth && width > opts.minWidth) width = opts.minWidth;
                    if ($('.fieldMergerPopup').length > 0) {
                        $('.fieldMergerPopup').remove();
                    } else {
                        const dropdown = $('<div class="fieldMergerPopup" style="position:absolute" tabindex="-1"></div>').css({
                            top: top,
                            left: offset.left,
                            width: width,
                            display: "none"
                        }).blur(function () {
                            $('.fieldMergerPopup').remove();
                        }).appendTo('body');
                        const upward = ((top - $(window).scrollTop()) + dropdown.outerHeight()) > $(window).height();
                        if (upward) {
                            dropdown.css({
                                top: offset.top - dropdown.outerHeight()
                            });
                        }
                        dropdown.show().focus();
                        _(opts.values).each(function (v, i) {
                            let label = HRX.getValueFromArrayOrNull(opts.labels, i);
                            if (!label) label = v;
                            let img = (opts.optionIcons.length > 0) ? '<img src="' + HRX.getValueFromArrayOrLast(opts.optionIcons, i) + '"/>' : '';
                            let emptyOption = (opts.emptyIcon) ? ('<img src="' + opts.emptyIcon + '"/>') : '[blank]';
                            $('<div class=".' + ((i > 1) ? 'oldValueItem' : 'newValueItem') + '" style="cursor:pointer">' + img + (label ? label : emptyOption) + '</div>').click(function (e) {
                                button.get(0).setTo(i);
                                e.preventDefault();
                            }).appendTo('.fieldMergerPopup');
                        });
                        $('.fieldMergerPopup').show();
                    }
                    e.preventDefault();
                };
                button.mousedown(onclick);
                onclick = null;
            } else if (opts.triggerStyle === "toggle") {
                button.iToggle({
                    onClickOn: function() {
                        button.get(0).setTo(0)
                    },
                    onClickOff: function() {
                        button.get(0).setTo(1)
                    },
                    keepLabel: false,
                    skin: '/rasp/mercury/themes/spring/components/fieldmerger/itoggle_small.png',
                    width: 47,
                    height: 14
                });
                opts.itoggle = button.get(0);
            }

            opts.field.bind("keyup change", setValueStyle).addClass(opts.fieldClass);
            if (opts.defaultNew) button.get(0).setTo(0); else setValueStyle();
        });
    };

    $.fn.hrxFieldMerger.defaults = {
        field: null,
        fieldClass: "merge_field",
        triggerStyle: "toggle",
        adjustFieldWidth: 0,
        offsetTop: 20,
        minWidth: 0,
        optionIcons: ['/rasp/mercury/themes/spring/components/fieldmerger/new.gif', '/rasp/mercury/themes/spring/components/fieldmerger/old.gif'],
        emptyIcon: null,
        values: ['', ''],
        styleClasses: ["merge_newvalue", "merge_oldvalue"],
        labels: [],
        defaultNew: false,
        handler: null
    }
}(jQuery));

/**
 * jQuery.ScrollTo
 * Copyright (c) 2007-2009 Ariel Flesler - aflesler(at)gmail(dot)com | http://flesler.blogspot.com
 * Dual licensed under MIT and GPL.
 * Date: 5/25/2009
 *
 * @projectDescription Easy element scrolling using jQuery.
 * http://flesler.blogspot.com/2007/10/jqueryscrollto.html
 * Works with jQuery +1.2.6. Tested on FF 2/3, IE 6/7/8, Opera 9.5/6, Safari 3, Chrome 1 on WinXP.
 *
 * @author Ariel Flesler
 * @version 1.4.2
 *
 * @id jQuery.scrollTo
 * @id jQuery.fn.scrollTo
 * @param {String, Number, DOMElement, jQuery, Object} target Where to scroll the matched elements.
 *	  The different options for target are:
 *		- A number position (will be applied to all axes).
 *		- A string position ('44', '100px', '+=90', etc ) will be applied to all axes
 *		- A jQuery/DOM element ( logically, child of the element to scroll )
 *		- A string selector, that will be relative to the element to scroll ( 'li:eq(2)', etc )
 *		- A hash { top:x, left:y }, x and y can be any kind of number/string like above.
*		- A percentage of the container's dimension/s, for example: 50% to go to the middle.
 *		- The string 'max' for go-to-end. 
 * @param {Number} duration The OVERALL length of the animation, this argument can be the settings object instead.
 * @param {Object,Function} settings Optional set of settings or the onAfter callback.
 *	 @option {String} axis Which axis must be scrolled, use 'x', 'y', 'xy' or 'yx'.
 *	 @option {Number} duration The OVERALL length of the animation.
 *	 @option {String} easing The easing method for the animation.
 *	 @option {Boolean} margin If true, the margin of the target element will be deducted from the final position.
 *	 @option {Object, Number} offset Add/deduct from the end position. One number for both axes or { top:x, left:y }.
 *	 @option {Object, Number} over Add/deduct the height/width multiplied by 'over', can be { top:x, left:y } when using both axes.
 *	 @option {Boolean} queue If true, and both axis are given, the 2nd axis will only be animated after the first one ends.
 *	 @option {Function} onAfter Function to be called after the scrolling ends. 
 *	 @option {Function} onAfterFirst If queuing is activated, this function will be called after the first scrolling ends.
 * @return {jQuery} Returns the same jQuery object, for chaining.
 *
 * @desc Scroll to a fixed position
 * @example $('div').scrollTo( 340 );
 *
 * @desc Scroll relatively to the actual position
 * @example $('div').scrollTo( '+=340px', { axis:'y' } );
 *
 * @dec Scroll using a selector (relative to the scrolled element)
 * @example $('div').scrollTo( 'p.paragraph:eq(2)', 500, { easing:'swing', queue:true, axis:'xy' } );
 *
 * @ Scroll to a DOM element (same for jQuery object)
 * @example var second_child = document.getElementById('container').firstChild.nextSibling;
 *			$('#container').scrollTo( second_child, { duration:500, axis:'x', onAfter:function(){
 *				alert('scrolled!!');																   
 *			}});
 *
 * @desc Scroll on both axes, to different values
 * @example $('div').scrollTo( { top: 300, left:'+=200' }, { axis:'xy', offset:-20 } );
 */
;(function( $ ){

    var $scrollTo = $.scrollTo = function( target, duration, settings ){
        $(window).scrollTo( target, duration, settings );
    };

    $scrollTo.defaults = {
        axis:'xy',
        duration: parseFloat($.fn.jquery) >= 1.3 ? 0 : 1
    };

    // Returns the element that needs to be animated to scroll the window.
    // Kept for backwards compatibility (specially for localScroll & serialScroll)
    $scrollTo.window = function( scope ){
        return $(window)._scrollable();
    };

    // Hack, hack, hack :)
    // Returns the real elements to scroll (supports window/iframes, documents and regular nodes)
    $.fn._scrollable = function(){
        return this.map(function(){
            let elem = this,
                isWin = !elem.nodeName || $.inArray( elem.nodeName.toLowerCase(), ['iframe','#document','html','body'] ) !== -1;

                if( !isWin )
                    return elem;

            const doc = (elem.contentWindow || elem).document || elem.ownerDocument || elem;

            return $.browser.safari || doc.compatMode === 'BackCompat' ?
                doc.body :
                doc.documentElement;
        });
    };

    $.fn.scrollTo = function( target, duration, settings ){
        if( typeof duration == 'object' ){
            settings = duration;
            duration = 0;
        }
        if( typeof settings == 'function' )
            settings = { onAfter:settings };

        if( target == 'max' )
            target = 9e9;

        settings = $.extend( {}, $scrollTo.defaults, settings );
        // Speed is still recognized for backwards compatibility
        duration = duration || settings.speed || settings.duration;
        // Make sure the settings are given right
        settings.queue = settings.queue && settings.axis.length > 1;

        if( settings.queue )
            // Let's keep the overall duration
            duration /= 2;
        settings.offset = both( settings.offset );
        settings.over = both( settings.over );

        return (this._scrollable()).each(function(){
            var elem = this,
                $elem = $(elem),
                targ = target, toff, attr = {},
                win = $elem.is('html,body');

            switch( typeof targ ){
                // A number will pass the regex
                case 'number':
                case 'string':
                    if( /^([+-]=)?\d+(\.\d+)?(px|%)?$/.test(targ) ){
                        targ = both( targ );
                        // We are done
                        break;
                    }
                    // Relative selector, no break!
                    targ = $(targ,this);
                case 'object':
                    // DOMElement / jQuery
                    if( targ.is || targ.style )
                        // Get the real position of the target
                        toff = (targ = $(targ)).offset();
            }
            $.each( settings.axis.split(''), function( i, axis ){
                var Pos	= axis == 'x' ? 'Left' : 'Top',
                    pos = Pos.toLowerCase(),
                    key = 'scroll' + Pos,
                    old = elem[key],
                    max = $scrollTo.max(elem, axis);

                if( toff ){// jQuery / DOMElement
                    attr[key] = toff[pos] + ( win ? 0 : old - $elem.offset()[pos] );

                    // If it's a dom element, reduce the margin
                    if( settings.margin ){
                        attr[key] -= parseInt(targ.css('margin'+Pos)) || 0;
                        attr[key] -= parseInt(targ.css('border'+Pos+'Width')) || 0;
                    }

                    attr[key] += settings.offset[pos] || 0;

                    if( settings.over[pos] )
                        // Scroll to a fraction of its width/height
                        attr[key] += targ[axis=='x'?'width':'height']() * settings.over[pos];
                }else{
                    var val = targ[pos];
                    // Handle percentage values
                    attr[key] = val.slice && val.slice(-1) == '%' ?
                        parseFloat(val) / 100 * max
                        : val;
                }

                // Number or 'number'
                if( /^\d+$/.test(attr[key]) )
                    // Check the limits
                    attr[key] = attr[key] <= 0 ? 0 : Math.min( attr[key], max );

                // Queueing axes
                if( !i && settings.queue ){
                    // Don't waste time animating, if there's no need.
                    if( old != attr[key] )
                        // Intermediate animation
                        animate( settings.onAfterFirst );
                    // Don't animate this axis again in the next iteration.
                    delete attr[key];
                }
            });

            animate( settings.onAfter );

            function animate( callback ){
                $elem.animate( attr, duration, settings.easing, callback && function(){
                    callback.call(this, target, settings);
                });
            }

        }).end();
    };

    // Max scrolling position, works on quirks mode
    // It only fails (not too badly) on IE, quirks mode.
    $scrollTo.max = function( elem, axis ){
        var Dim = axis == 'x' ? 'Width' : 'Height',
            scroll = 'scroll'+Dim;

        if( !$(elem).is('html,body') )
            return elem[scroll] - $(elem)[Dim.toLowerCase()]();

        var size = 'client' + Dim,
            html = elem.ownerDocument.documentElement,
            body = elem.ownerDocument.body;

        return Math.max( html[scroll], body[scroll] ) - Math.min( html[size]  , body[size]   );

    };

    function both( val ){
        return typeof val == 'object' ? val : { top:val, left:val };
    }

})( jQuery )

;(function($) {
    if (!HRX['hideColumnFilterOnBlur']) {
        HRX.hideColumnFilterOnBlur = function(e) {
            var popup = $('.RaspPopupPanel:visible');
            if (popup.size  === 0) {
                $(document).unbind('click', HRX.hideColumnFilterOnBlur);
            } else {
                var popupContent = popup.children('.tip');
                var offset = popupContent.offset();
                if (offset && offset.left &&
                    (e.pageX < offset.left ||
                        e.pageX > offset.left + popupContent.outerWidth() ||
                        e.pageY < offset.top ||
                        e.pageY > offset.top + popupContent.outerHeight())) {
                    //the column header will check on visibility of the popup to prevent it shows up again.
                    setTimeout(function() {jQuery(".RaspPopupPanel:visible").hide()}, 50);
                    $(document).unbind('click', HRX.hideColumnFilterOnBlur);
                }
            }
        }
    }

    if (!HRX['showColumnFilter']) {
        HRX.showColumnFilter = function(columnName, container, offsetX) {
            var adjustPosition = function(popup) {
                var deltaX = popup.offset().left - popup.position().left;
                var popupWidth = popup.children('.tip').outerWidth();
                var left = HRX.cursor.X + offsetX ;
                var containerRight = $(container).offset().left + $(container).width();
                if (left + popupWidth > containerRight) left = containerRight - popupWidth - 10;
                left = left - deltaX;
                if (left < 5) left = 5;
                popup.css('left', left);
            };
            var popupPanel = $(HRX.idToSelector('#' + columnName + '-popup'));
            if (!popupPanel.is(':visible')) {
                popupPanel.show();
                adjustPosition(popupPanel);
                $(document).bind('click', HRX.hideColumnFilterOnBlur);
            } else popupPanel.hide();
        }
    }
})(jQuery);

/**
 * IFrame enhancement
 */

HRX.iframeRedirect = function(selector, url, squirt) {
    var ifm = jQuery(selector);
    if (ifm.size() === 0) return;
    HRX.iframeSquirt(ifm, squirt);
    ifm.attr('src', url);
};

HRX.iframeSquirt = function(selector, squirt) {
    var ifm = jQuery(selector);
    if (ifm.size() === 0) return;
    if (typeof(squirt) !== 'undefined') {
        var el = ifm.get(0);
        var doc = el.contentDocument || el.contentWindow.document;
        doc.open();
        doc.writeln(squirt);
        doc.close();
    }
}

;(function($) {

    var timer;

    $.fn.src = function (url, onLoad, options) {
        setIFrames($(this), onLoad, options, function () {
            this.src = url;
        });
        return $(this);
    };

    $.fn.squirt = function (content, onLoad, options) {

        setIFrames($(this), onLoad, options, function () {
            var doc = null;
            if (typeof(this.contentDocument) != 'unknown') {
                doc = this.contentDocument;
            } else if (typeof(this.contentWindow) != "unknown" && typeof(this.contentWindow.document) != "unknown") {
                doc = this.contentWindow.document;
            }
            if (doc) {
                doc.open();
                doc.writeln(content);
                doc.close();
            }
        });
        return this;
    };

  function setIFrames(iframes, onLoad, options, iFrameSetter) {
    iframes.each(function() {
      if (this.tagName=="IFRAME") setIFrame(this, onLoad, options, iFrameSetter);
    });
  }

  function setIFrame(iframe, onLoad, options, iFrameSetter) {
    var timer;
    iframe.onload = null;
    if (timer) clearTimeout(timer);

    var defaults = {
      timeoutDuration: 0,
      timeout: null
    };
    var opts = $.extend(defaults, options);
    if (opts.timeout && !opts.timeoutDuration) opts.timeoutDuration = 60000;

    opts.frameactive = true;
    var startTime = (new Date()).getTime();
    if (opts.timeout) {
        timer = setTimeout(function() {
            opts.frameactive=false;
            iframe.onload=null;
            if (opts.timeout) opts.timeout(iframe, opts.timeout);
        }, opts.timeoutDuration);
    }

    var onloadHandler = function() {
      var duration=(new Date()).getTime()-startTime;
      if (timer) clearTimeout(timer);
      if (onLoad && opts.frameactive) onLoad.apply(iframe,[duration]);
      opts.frameactive=false;
    };
    iFrameSetter.apply(iframe);
    iframe.onload = onloadHandler;
    opts.completeReadyStateChanges=0;
    iframe.onreadystatechange = function() { // IE ftw
        if (++(opts.completeReadyStateChanges)==3) onloadHandler();
    };
    return iframe;
  }
})(jQuery);

/**
 * Really Simple Color Picker in jQuery
 * 
 * Licensed under the MIT (MIT-LICENSE.txt) licenses.
 *
 * Copyright (c) 2008 Lakshan Perera (www.laktek.com)
 *                    Daniel Lacy (daniellacy.com)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

;(function ($) {
    /**
     * Create a couple private variables.
    **/
    var selectorOwner,
        activePalette,
        cItterate       = 0,
        templates       = {
            control : $('<div class="colorPicker-picker">&nbsp;</div>'),
            palette : $('<div id="colorPicker_palette" class="colorPicker-palette" />'),
            clearButton : $('<div class="colorPicker-swatch colorPicker-empty">&nbsp;</div>'),
            swatch  : $('<div class="colorPicker-swatch">&nbsp;</div>'),
            hexLabel: $('<label for="colorPicker_hex">Code</label>'),
            hexField: $('<input type="text" id="colorPicker_hex" />')
        },
        transparent     = "transparent",
        lastColor;

    /**
     * Create our colorPicker function
    **/
    $.fn.simpleColorPicker = function (options) {
        return this.each(function () {
            // Setup time. Clone new elements from our templates, set some IDs, make shortcuts, jazzercise.
            var element      = $(this),
                opts         = $.extend({}, $.fn.simpleColorPicker.defaults, options),
                defaultColor = (element.val().length > 0) ? $.fn.simpleColorPicker.toHex(element.val()) : '',
                newControl   = templates.control.clone(),
                newPalette   = templates.palette.clone().attr('id', 'colorPicker_palette-' + cItterate),
                newHexLabel  = templates.hexLabel.clone(),
                newHexField  = templates.hexField.clone(),
                newClearButton = templates.clearButton.clone(),
                paletteId    = newPalette[0].id,
                swatch;

            /**
             * Build a color palette.
            **/
            $.each(opts.colors, function (i) {
                swatch = templates.swatch.clone();

                if (opts.colors[i] === transparent) {
                    swatch.addClass(transparent).text('X');

                    $.fn.simpleColorPicker.bindPalette(newHexField, swatch, transparent);

                } else {
                    swatch.css("background-color", "#" + this);
                    if (opts.colorLabels.length > i) {
                        swatch.attr('title', opts.colorLabels[i]);
                    }

                    $.fn.simpleColorPicker.bindPalette(newHexField, swatch);
                }

                swatch.appendTo(newPalette);
            });

            newClearButton.appendTo(newPalette).css("background-color", "#FFF").attr('title', 'Clear');
            $.fn.simpleColorPicker.bindEmptySwatch(newHexField, newClearButton);

            newHexField.attr({
                'id'    : 'colorPicker_hex-' + cItterate,
                'value' : defaultColor
            });

            newHexField.bind("keydown", function (event) {
                if (event.keyCode === 13) {
                    $.fn.simpleColorPicker.changeColor($.fn.simpleColorPicker.toHex($(this).val()));
                }
                if (event.keyCode === 27) {
                    $.fn.simpleColorPicker.hidePalette(paletteId);
                }
            });

            $('<div class="colorPicker_hexWrap" />').appendTo(newPalette);

            newPalette.find('.colorPicker_hexWrap').append(newHexField);

            $("body").append(newPalette);

            newPalette.hide();


            /**
             * Build replacement interface for original color input.
            **/
            newControl.css("background-color", defaultColor);

            newControl.bind("click", function () {
                $.fn.simpleColorPicker.togglePalette($('#' + paletteId), $(this));
            });

            element.after(newControl);

            element.bind("change", function () {
                var $this = $(this);
                if ($this.val() === "") {
                    element.next(".colorPicker-picker").css("background-color", "#FFF").addClass("colorPicker_clear");
                } else {
                    element.next(".colorPicker-picker").css("background-color", $.fn.simpleColorPicker.toHex($this.val())).removeClass("colorPicker_clear");
                }
            });

            element.change();

            // Hide the original input.
            element.val(defaultColor).hide();

            cItterate++;
        });
    };

    /**
     * Extend colorPicker with... all our functionality.
    **/
    $.extend(true, $.fn.simpleColorPicker, {
        /**
         * Return a Hex color, convert an RGB value and return Hex, or return false.
         *
         * Inspired by http://code.google.com/p/jquery-color-utils
        **/
        toHex : function (color) {
            // If we have a standard or shorthand Hex color, return that value.
            if (color.match(/[0-9A-F]{6}|[0-9A-F]{3}$/i)) {
                return (color.charAt(0) === "#") ? color : ("#" + color);

            // Alternatively, check for RGB color, then convert and return it as Hex.
            } else if (color.match(/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/)) {
                var c = ([parseInt(RegExp.$1, 10), parseInt(RegExp.$2, 10), parseInt(RegExp.$3, 10)]),
                    pad = function (str) {
                        if (str.length < 2) {
                            for (var i = 0, len = 2 - str.length; i < len; i++) {
                                str = '0' + str;
                            }
                        }

                        return str;
                    };

                if (c.length === 3) {
                    var r = pad(c[0].toString(16)),
                        g = pad(c[1].toString(16)),
                        b = pad(c[2].toString(16));

                    return '#' + r + g + b;
                }

            // Otherwise we wont do anything.
            } else {
                return false;

            }
        },

        /**
         * Check whether user clicked on the selector or owner.
        **/
        checkMouse : function (event, paletteId) {
            var selector = activePalette,
                selectorParent = $(event.target).parents("#" + selector.attr('id')).length;

            if (event.target === $(selector)[0] || event.target === selectorOwner || selectorParent > 0) {
                return;
            }

            $.fn.simpleColorPicker.hidePalette();
        },

        /**
         * Hide the color palette modal.
        **/
        hidePalette : function (paletteId) {
            $(document).unbind("mousedown", $.fn.simpleColorPicker.checkMouse);

            $('.colorPicker-palette').hide();
        },

        /**
         * Show the color palette modal.
        **/
        showPalette : function (palette) {
            var hexColor = selectorOwner.prev("input").val();

            palette.css({
                top: selectorOwner.offset().top + (selectorOwner.outerHeight()),
                left: selectorOwner.offset().left
            });

            $("#color_value").val(hexColor);

            palette.show();

            $(document).bind("mousedown", $.fn.simpleColorPicker.checkMouse);
        },

        /**
         * Toggle visibility of the colorPicker palette.
        **/
        togglePalette : function (palette, origin) {
            // selectorOwner is the clicked .colorPicker-picker.
            if (origin) {
                selectorOwner = origin;
            }

            activePalette = palette;

            if (activePalette.is(':visible')) {
                $.fn.simpleColorPicker.hidePalette();

            } else {
                $.fn.simpleColorPicker.showPalette(palette);

            }
        },

        /**
         * Update the input with a newly selected color.
        **/
        changeColor : function (value) {
            selectorOwner.css("background-color", value);
            selectorOwner.prev("input").val(value).change();
            $.fn.simpleColorPicker.hidePalette();
        },

        clearColor : function() {
            selectorOwner.css("background-color", "#FFF");
            selectorOwner.prev("input").val("").change();
            $.fn.simpleColorPicker.hidePalette();
        },

        /**
         * Bind events to the color palette swatches.
        */
        bindPalette : function (paletteInput, element, color) {
            color = color ? color : $.fn.simpleColorPicker.toHex(element.css("background-color"));

            element.bind('click', function (ev) {
                    lastColor = color;

                    $.fn.simpleColorPicker.changeColor(color);
                });
            element.bind('mouseover', function (ev) {
                    lastColor = paletteInput.val();

                    $(this).css("border-color", "#598FEF");

                    paletteInput.val(color);
                });
            element.bind('mouseout', function (ev) {
                    $(this).css("border-color", "#000");

                    paletteInput.val(selectorOwner.css("background-color"));

                    paletteInput.val(lastColor);
                });
        },

        /**
         *
         */
        bindEmptySwatch : function(paletteInput, element) {
            element.bind('click', function(ev) {
                    lastColor = "";
                    $.fn.simpleColorPicker.clearColor();
                });
            element.bind('mouseover', function (ev) {
                    lastColor = paletteInput.val();

                    $(this).css("border-color", "#598FEF");

                    paletteInput.val("");
                });
            element.bind('mouseout', function (ev) {
                    $(this).css("border-color", "#000");

                    paletteInput.val(selectorOwner.css("background-color"));

                    paletteInput.val(lastColor);
                });
        }
    });

    /**
     * Default colorPicker options.
     *
     * These are publibly available for global modification using a setting such as:
     *
     * $.fn.simpleColorPicker.defaults.colors = ['151337', '111111']
     *
     * They can also be applied on a per-bound element basis like so:
     *
     * $('#element1').colorPicker({pickerDefault: 'efefef', transparency: true});
     * $('#element2').colorPicker({pickerDefault: '333333', colors: ['333333', '111111']});
     *
    **/
    $.fn.simpleColorPicker.defaults = {
        // colorPicker default selected color.
        pickerDefault : "FFFFFF",

        // Default color set.
        colors : ['339966', '33CCCC', '3366FF', '800080', '999999'],

        colorLabels : [],

        // If we want to simply add more colors to the default set, use addColors.
        addColors : []
    };

})(jQuery);

//TinyMCE
;(function() {
    if (typeof tinymce === 'undefined') return;
    const defaultOptions = {
        mode: "specific_textareas",
        theme: "advanced",
        plugins: "pagebreak,style,table,save,advhr,advimage,advlink,iespell,insertdatetime,inlinepopups,preview,media,searchreplace,contextmenu,paste,directionality,fullscreen,noneditable,visualchars,nonbreaking,xhtmlxtras,template,advlist,spellchecker,fullpage",
        pagebreak_separator: "<div style=\"page-break-after: always;\"><span style=\"display: none;\"></span></div>",
        theme_advanced_buttons1: "bold,italic,underline,|,justifyleft,justifycenter,justifyright,justifyfull,fontselect,fontsizeselect,forecolor,charmap",
        theme_advanced_buttons2: "cut,copy,paste,pastetext,pasteword,|,search,replace,|,bullist,numlist,|,outdent,indent,|,undo,redo,|,link,unlink,anchor,image,help,code, spellchecker",
        theme_advanced_buttons3_add: "fullpage",
        theme_advanced_buttons4: "",
        theme_advanced_toolbar_location: "top",
        theme_advanced_toolbar_align: "left",
        theme_advanced_statusbar_location: "bottom",
        theme_advanced_resizing: true,
        add_form_submit_trigger: false,
        theme_advanced_path: false,
        spellchecker_languages: "+English=en-AU",
        spellchecker_rpc_url: "/rasp6/jazzy-spellchecker",
        content_css: "css/content.css",
        template_external_list_url: "lists/template_list.js",
        external_link_list_url: "lists/link_list.js",
        external_image_list_url: "lists/image_list.js",
        media_external_list_url: "lists/media_list.js",
        fullpage_default_title: "Springboard Announcement",
        relative_urls : false,
        remove_script_host : false,
        convert_urls : false,
        invalid_elements : "script,javascript,expression,embed,object",
        style_formats: [
            {title: 'Bold text', inline: 'b'},
            {title: 'Red text', inline: 'span', styles: {color: '#ff0000'}},
            {title: 'Red header', block: 'h1', styles: {color: '#ff0000'}},
            {title: 'Example 1', inline: 'span', classes: 'example1'},
            {title: 'Example 2', inline: 'span', classes: 'example2'},
            {title: 'Table styles'},
            {title: 'Table row 1', selector: 'tr', classes: 'tablerow1'}
        ]
    };
    const defaultFinder = function() {return true};
    
    /**
     * Remove a tinymce editor from the page environment.
     * tinymce.remove (at least up to 3.5.11) does not remove the editor from editors array.
     * We need to do it manually. -- DD 31/03/2016 11:20:04 am
     */
    HRX.removeTinyMCEInstance = function(editor) {
        let oldLength = tinymce.editors.size();
        tinymce.remove(editor);
        if (oldLength === tinymce.editors.size()) {
            tinymce.editors.remove(editor)
        }
    };
    
    HRX.initTinyMCE = function(selector, options, finder) {
        if (!finder) finder = defaultFinder;
        tinymce.editors.filter(finder).each(function(e) {
                try {
                    HRX.removeTinyMCEInstance(e)
                } catch (err) {
                    LOG.error(err)
                }
            }
        );
        const opt = jQuery.extend(true, {}, defaultOptions, options, {editor_selector: selector});
        tinymce.init(opt)
    };

    /**
     * Remove tinymce editors for each id group except the last one.
     */
    HRX.cleanUpTinyMCE = function() {
        _.chain(tinymce.editors)
            .groupBy(function(editor) {return editor.id})
            .values()
            .each(function (editors) {
                _.chain(editors).initial().each(function(leakedEditor) {
                    try {
                        HRX.removeTinyMCEInstance(leakedEditor)
                    } catch (err) {
                        app.console.error(err)
                    }
                })
            })
    }
})();

app.registerConstructor("AjaxIndicators", function () {
    window.indicators = {};

    const AjaxIndicator = function(opts) {
        const self = this;
        let stopTimer = null;
        this.jqId = opts.jqId;
        this.varName = opts.varName;
        this.holdPlace = opts.holdPlace;
        this.timeout = opts.timeout;
        this.onstart = opts.onstart || _.noop;
        this.onstop = opts.onstop || _.noop;

        function clearStopTimer() {
            if (stopTimer) {
                clearTimeout(stopTimer);
                stopTimer = null;
            }
        }

        /**
         * Start the indicator
         * @param options
         */
        this.start = function(options) {
            clearStopTimer();
            const timeout = (options && options.timeout) || self.timeout;
            if (timeout && timeout > 0) {
                stopTimer = setTimeout(function() {
                    self.stop();
                }, timeout);
            }
            if (self.holdPlace) {
                $(self.jqId).css("visibility", "visible");
            } else {
                $(self.jqId).css("display", "inline-block");
            }
            self.onstart(self);
        };

        this.stop = function() {
            clearStopTimer();
            if (self.holdPlace) {
                $(self.jqId).css("visibility", "hidden");
            } else {
                $(self.jqId).css("display", "none");
            }
            self.onstop(self);
        }
    };

    /**
     * Creates a ajax indicator js model
     * @param {string} jqId - The client id of the wrapping element
     * @param {string} varName - The unique name to be used to refer the indicator.
     * @param {boolean} holdPlace - Reserve space when the icon is hidden.
     * @param timeout - stop the indicator if it is not explicitly stopped before the timeout in milliseconds.
     */
    this.createIndicator = function(jqId, varName, holdPlace, timeout, onstart, onstop) {
        jqId = jqId.replace(/:/g, "\\:");
        window.indicators[varName] = new AjaxIndicator({
            jqId: jqId,
            varName: varName,
            holdPlace: holdPlace,
            timeout: timeout,
            onstart: _.isString(onstart) ? new Function('vm', onstart) : null,
            onstop: _.isString(onstop) ? new Function('vm', onstop) : null
        })
    }
}).createVM();


//TK VIC JOBS BOARDS WCAGE fix 12/07/2023
function frontendPortlet() {
    mobileMenu();
    
    $('form.candidate-profile-tab-form').attr('role','presentation');
    $('#candidateProfileUploaderId').attr('role','presentation');
    
    //remove aria-describedby fron div and input
    $("div[aria-describedby],input[aria-describedby]").each(function () {
        $(this).removeAttr("aria-describedby");
    });

    //add some text for read
    $("input.uppy-Dashboard-input").each(function () {
        $(this).attr("aria-label", "Drag & Drop Files Here or browse");
    });

    $("input.ui-inputfield").each(function () {
        if (!$(this).is(':visible')) {
            $(this).attr("aria-label", "hidden input");
        }
    });
    $(".ui-selectonemenu-trigger").each(function () {
        if (!$(this).is(':visible')) {
            $(this).attr("aria-label", "hidden input");
        }
    });

    //add placeholder for date formet
    $("input[id*='p_dateOfBirth_input']").attr("placeholder", "DD-MMM-YYYY");

    //add tabindx on headings for focus    
    $("h1,h4,h3, #privacy-section-heading").attr("role", "heading");
    $(".panel-title").removeAttr("aria-hidden");    
    $('.formio-component-select .form-control[tabindex="0"] select[tabindex="-1"]').each(function () {
        $(this).closest('.formio-component-select').find('.control-label').removeAttr('for');
        $(this).closest('.formio-choices').attr('aria-label', 'button');
        $(this).closest('.formio-choices').removeAttr('role');
        $(this).closest('.form-control[tabindex="0"]').attr('role', 'button');
    });
    
    //add label and tabindex to select box
     $(".ui-selectonemenu.form-control").each(function () {
        $(this).find('.ui-selectonemenu-trigger').attr('tabindex','-1');
        $(this).find('.ui-selectonemenu-trigger').attr('aria-hidden','true');
     });

    
    $('.formio-component .input-group .form-control[placeholder="dd/MM/yyyy"]').each(function () {
        var input = $(this);
        var IDdate = input.attr('id');
        if (!IDdate) {
            input.closest('.input-group').find('.form-control').removeAttr('id');
            var IDInput = input.closest('.formio-component').find('.control-label').attr('for');
            input.attr('id', IDInput);
        }
        input.closest('.input-group').find('.fa').attr('aria-hidden', 'true');
        input.closest('.input-group').find('.input-group-addon').attr({
            'tabindex': '0',
            'role': 'button',
            'aria-label': 'Open Calendar'
        });
    });
    
    setTimeout(function () {
        $(document).keyup(function (e) {
            var activeItem = document.activeElement;
            
            //add label and tabindex to select box
             $(".ui-selectcheckboxmenu-token.ui-state-active").each(function () {
                 var selectcheckboxmenuText = $(this).text();
                 $(this).find('.ui-selectcheckboxmenu-token-icon').attr('tabindex', '0');
                 $(this).find('.ui-selectcheckboxmenu-token-icon').attr('role', 'button');
                 $(this).find('.ui-selectcheckboxmenu-token-icon').attr('aria-label', 'use enter and space for remove '+selectcheckboxmenuText);
             });
            
            //any arrow key
            if (e.keyCode == 37 || e.keyCode == 38 || e.keyCode == 39 || e.keyCode == 40) {
                $('.ui-button.ui-state-focus').removeClass('ui-state-focus');
                if ($(activeItem).hasClass('ui-helper-hidden-accessible')) {
                    $(activeItem).parent('.ui-button').addClass('ui-state-focus');
                }
            }        
            
            // enter and space key
            if (e.keyCode == 32 || e.keyCode == 13) {
                setTimeout(function () {
                    if ($('.ui-messages').text().length > 1) {
                        $('.ui-messages').focus();
                    }
                }, 500);
                
                if ($(activeItem).hasClass('ui-selectcheckboxmenu-token-icon')) {
                    $(activeItem).click();
                }

                if ($(activeItem).hasClass('mdi-trash-can-outline')) {
                    $(activeItem).addClass('ui-dialog-open');
                }

                if ($(activeItem).hasClass('btn-secondary')) {
                    if ($('.ui-dialog').is(':visible')) {
                        $('.ui-dialog-open').focus();
                        $('.ui-dialog-open').removeClass('ui-dialog-open');
                    }
                }

                if ($(activeItem).hasClass('ui-state-default')) {
                    $('input.hasDatepicker-Show').focus();
                    $('input.hasDatepicker-Show').removeClass('hasDatepicker-Show');
                    setTimeout(function () {
                        $('#ui-datepicker-div').hide();
                    }, 200);
                }

                if ($(activeItem).hasClass('btn-back-to-top')) {
                    setTimeout(function () {
                        $(".theme-heading").attr("tabindex", "0").focus();
                    }, 200);
                }

                setTimeout(function () {
                    if ($('.ui-dialog').is(':visible')) {
                        $('.ui-dialog').find(':focusable').first().focus();
                    }

                    if (!$('.ui-dialog').is(':visible')) {
                        $('.ui-dialog-open').focus();
                        $('.ui-dialog-open').removeClass('ui-dialog-open');
                    }
                }, 200);
            }

            // tab key
            if (e.keyCode == 9) {
                if ($(activeItem).hasClass('hasDatepicker')) {
                    $(activeItem).addClass('hasDatepicker-Show');
                    setTimeout(function () {
                        $('#ui-datepicker-div').attr('tabindex', '0');
                        $('#ui-datepicker-div .ui-datepicker-prev').attr('tabindex', '0').focus();
                    }, 200);
                }
            }

            // esc key
            if (e.keyCode == 27) {
                if ($('#ui-datepicker-div').is(':visible')) {
                    $('input.hasDatepicker-Show').focus();
                    $('#ui-datepicker-div').hide();
                    $('input.hasDatepicker-Show').removeClass('hasDatepicker-Show');
                }

                if ($('.ui-dialog-open').length) {
                    setTimeout(function () {
                        $('.ui-dialog-open').focus();
                        $('.ui-dialog-open').removeClass('ui-dialog-open');
                    }, 200);
                }

                if ($('.ui-dialog').is(':visible')) {
                    $('.ui-dialog-open').focus();
                    $('.ui-dialog-open').removeClass('ui-dialog-open');
                    $('.ui-dialog .ui-button[name*="cancelUppyButton"]').click();
                }
            }

        });

        $(document).keydown(function (e) {
            if (e.keyCode == 9) {
                if ($('#ui-datepicker-div').is(':visible')) {
                    if ($('#ui-datepicker-div').has(document.activeElement).length) {
                        var lastFocusDate = $('#ui-datepicker-div').find(':focusable').last();
                        if (document.activeElement === lastFocusDate[0]) {
                            $('#ui-datepicker-div').focus();
                        }
                    }else{
                         $('#ui-datepicker-div').focus();
                    }
                }

                if ($('.ui-dialog').is(':visible')) {
                    var firstDialogLink = $('.ui-dialog').find(':focusable').first();
                    var lastDialogLink = $('.ui-dialog').find(':focusable').last();
                    if (document.activeElement === lastDialogLink[0]) {
                        setTimeout(function () {
                            firstDialogLink.focus();
                        }, 100);
                    }
                }
            }

            if (e.shiftKey && e.keyCode == 9) {
                if ($('#ui-datepicker-div').is(':visible')) {
                    var lastFocusDate = $('#ui-datepicker-div').find(':focusable').last();
                    if ($(document.activeElement).hasClass('ui-datepicker-prev')) {
                        lastFocusDate.focus();
                        setTimeout(function () {
                            lastFocusDate.focus();
                        }, 100);
                    }
                }
            }
        });
    }, 300);
}


function mobileMenu() {
    var isMobile = /Mobi/i.test(navigator.userAgent);
    if (isMobile) {
        $(document).keydown(function (e) {
            if ($('.navbar.navbar-collapse.collapse.in').length) {
                var activeMenuLink = document.activeElement;
                var firstMenuLink = $('.site-header').find(':focusable').first();
                var lastMenuLink = $('.site-header').find(':focusable').last();

                if (e.keyCode == 27) {
                    if($('.navbar-toggle.active').length){
                        $('.navbar-toggle.active').click();                       
                    }
                }
                
                if (e.keyCode == 9) {
                    if (document.activeElement === lastMenuLink[0]) {
                        firstMenuLink.focus();
                        setTimeout(function () {
                            firstMenuLink.focus();
                        }, 100);
                    }
                }
                
                if (e.shiftKey && e.keyCode == 9) {
                    if (document.activeElement === firstMenuLink[0]) {
                        lastMenuLink.focus();
//                        setTimeout(function () {
//                            lastMenuLink.focus();
//                        }, 100);
                    }
                }
            }
        });
    }
}
